import type { SyncMode } from "./SyncModeFields";

export type Protocol = "oidc" | "saml";

export const DEFAULT_OIDC_SCOPES = [
  "openid",
  "email",
  "profile",
  "offline_access",
];

export function parseScopes(value: string): string[] {
  return value.split(/[\s,]+/).filter(Boolean);
}

export type SamlMapping = {
  email: string;
  firstName: string;
  lastName: string;
  image: string;
};

export const emptyMapping: SamlMapping = {
  email: "",
  firstName: "",
  lastName: "",
  image: "",
};

export type SsoConfig = {
  protocol: Protocol;
  providerId: string;
  issuer: string;
  domain: string;
  clientId: string;
  clientSecret: string;
  scopes: string;
  entryPoint: string;
  cert: string;
  metadataUrl: string;
  metadataXml: string;
  mapping: SamlMapping;
  syncMode: SyncMode;
};

export const emptySsoConfig: SsoConfig = {
  protocol: "oidc",
  providerId: "",
  issuer: "",
  domain: "",
  clientId: "",
  clientSecret: "",
  scopes: "",
  entryPoint: "",
  cert: "",
  metadataUrl: "",
  metadataXml: "",
  mapping: { ...emptyMapping },
  syncMode: "off",
};
